import { connect } from 'react-redux';
import { applySpec } from 'ramda';
import PatientList from 'components/PatientList';
import { getUserRole, getUserId, getUserRegion } from 'store/selectors/user';
import { notificationsAdd } from 'virtues-bootstrap';

const mapStateToProps = applySpec({
  userId: getUserId,
  role: getUserRole,
  region: getUserRegion,
});

const mapDispatchToProps = {
  notificationsAdd,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PatientList);
